import * as Yup from 'yup';

export const schema = Yup.object().shape({
	identifier: Yup.string().required('required'),
});
